import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { TabData, TabSubtitle } from '../../models/tab.interface';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-page-link-tab',
  templateUrl: './page-link-tab.component.html',
  styleUrls: ['./page-link-tab.component.scss'],
})
export class PageLinkTabComponent implements OnInit {
  selected: string;
  subtitleSelected = '';

  @Input() tabs: TabData[];
  @Input() description: string;
  @Input() defaultSelected: string;

  @Output() tabSelected = new EventEmitter<string>();

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    // are we routing to a specific tab in the url?
    const tabSpecified = this.tabs.find(t => this.router.url.includes(t.link));
    // set selected based on url or default
    this.selected = tabSpecified ? tabSpecified.value : this.defaultSelected;
    // set highlighted fragment if one is specified in the url
    const fragment = this.router.url.split('#')[1];
    this.subtitleSelected = fragment ? fragment : '';
  }

  subtitleLink(subtitle: TabSubtitle, tab: TabData): void {
    if (this.selected === tab.value) {
      this.subtitleSelected = subtitle.value;
    }
  }

  updateSelected(value: string, link: string): void {
    this.selected = value;
    this.tabSelected.emit(value);
    // remove fragment if navigating to new tab
    const tab = this.tabs.find(t => t.value === value);
    if (!tab.subtitles.find(s => s.value === this.subtitleSelected)) {
      this.subtitleSelected = null;
    }
    // navigate to the correct tab content
    this.router.navigate([link], {
      relativeTo: this.route,
      fragment: this.subtitleSelected
    });
  }

  isSelected(value: string): 'selected' | 'unselected' {
    return this.selected === value ? 'selected' : 'unselected';
  }

  isHeaderSelected(value: string): 'headerSelected' | '' {
    return this.selected === value ? 'headerSelected' : '';
  }

  isSubtitleSelected(value: string): 'subtitleSelected' | '' {
    return this.subtitleSelected === value ? 'subtitleSelected' : '';
  }
}
